import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const ROADDISTANCE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.RoadDistance.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const ROADDISTANCE_CONFIG = {
  entityName: 'RoadDistance',
  localizationKey: 'Controlling::Entity.RoadDistance',
  fields: ROADDISTANCE_FIELDS,
  permission: 'ControllingActivities.RoadDistances',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
